<p>Contact your admin for authorization</p>
<button mat-raised-button (click) = "logout()">Logout</button>